import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Trans } from 'react-i18next';
import colors from 'hsl-shared-components/lib/Theme/colors';
import CardReaderButton from '../../components/CardReaderButton';
import CurrentZoneIndicator from '../../components/CurrentZoneIndicator';
import {
  getRelativeHeight,
  getRelativeWidth,
} from '../../components/CardReader/CardReader';

const BackButton = styled(CardReaderButton)`
  position: absolute;
  top: ${getRelativeHeight(36)};
  left: ${getRelativeHeight(4)};
  height: ${getRelativeHeight(49)};
  width: ${getRelativeWidth(49)};
  z-index: 1;
`;

const TicketZone = styled.div`
  position: absolute;
  top: ${getRelativeHeight(36)};
  left: ${getRelativeWidth(2)};
  width: ${getRelativeWidth(396)};
  display: flex;
  justify-content: center;
  font-size: 2.75em;
  font-weight: 700;
`;

const PlusMinusInput = styled.div`
  position: absolute;
  top: ${getRelativeHeight(90)};
  left: ${getRelativeWidth(106)};
  right: ${getRelativeWidth(106)};
  bottom: ${getRelativeHeight(72)};
  user-select: none;
`;

const MinusButton = styled(CardReaderButton)`
  position: absolute;
  top: 0;
  bottom: 20;
  left: 0;
  height: ${getRelativeHeight(244)};
  width: ${getRelativeWidth(118)};
`;

const PlusButton = styled(MinusButton)`
  left: auto;
  right: 0;
`;

const Count = styled.div`
  position: absolute;
  top: ${getRelativeHeight(4)};
  left: ${getRelativeWidth(120)};
  height: ${getRelativeHeight(236)};
  width: ${getRelativeWidth(158)};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3em;
  font-weight: 700;
  color: ${colors.primary.hslGreyDark};
`;

const ContinueButton = styled(CardReaderButton)`
  position: absolute;
  right: ${getRelativeWidth(12)};
  bottom: ${getRelativeHeight(10)};
  left: ${getRelativeWidth(12)};
  height: ${getRelativeHeight(62)};
  padding-top: ${getRelativeHeight(1)};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4em;
  font-weight: 700;
  text-transform: uppercase;
`;

const PassengersScreenContent = ({
  currentZone,
  ticketZones,
  ticketPassengers,
  onBackButtonClick,
  onMinusButtonClick,
  onPlusButtonClick,
  onContinueButtonClick,
}) => (
  <>
    <CurrentZoneIndicator>{currentZone[0]}</CurrentZoneIndicator>
    <BackButton onClick={onBackButtonClick} />
    <TicketZone>{ticketZones}</TicketZone>
    <PlusMinusInput>
      <MinusButton onClick={onMinusButtonClick} />
      <Count>{ticketPassengers}</Count>
      <PlusButton onClick={onPlusButtonClick} />
    </PlusMinusInput>
    <ContinueButton onClick={onContinueButtonClick}>
      <Trans i18nKey="Generic.confirm" />
    </ContinueButton>
  </>
);

PassengersScreenContent.propTypes = {
  currentZone: PropTypes.string.isRequired,
  ticketZones: PropTypes.string.isRequired,
  ticketPassengers: PropTypes.number.isRequired,
  onBackButtonClick: PropTypes.func.isRequired,
  onMinusButtonClick: PropTypes.func.isRequired,
  onPlusButtonClick: PropTypes.func.isRequired,
  onContinueButtonClick: PropTypes.func.isRequired,
};

export default PassengersScreenContent;
